'use client'

import { useQueryParams } from '@/hooks/use-query-params'
import cx from 'classnames'
import Link from 'next/link'
import { useScrollLock } from 'usehooks-ts'
import s from './modal-pane.module.scss'

export const ModalPaneBackgroundClient = () => {
  useScrollLock()
  const { getLinkWith } = useQueryParams()
  const closeModalLink = getLinkWith({ modal: null })

  return (
    <Link href={closeModalLink} scroll={false} className={cx(s.background)} />
  )
}
